import styled from "styled-components";



export const Container = styled.div`
 padding: 4rem;
`

export const PrimaryText = styled.h1`
 font-size: 1.2rem;
 font-weight: bold;
 color: ${({ theme,bg }) => bg ? bg :theme.colors.primary};
`

export const SecondaryText = styled.h1`
 color: ${({ theme,bg }) => bg?bg:theme.colors.primary};
`

